export default __webpack_public_path__ + "static/beskyttelsesomrade-69b5048611263b45d2cb8280f4291f24.png";